import axios from 'axios';
import Cookie from 'js-cookie';
import Router from '@/router';

const baseURL = 'https://test-fleet.gladmobile.com/web/api';
// const baseURL = 'https://staging.ap.gladmobile.com/web/api';

const backendAPI = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json'
  }
});

backendAPI.interceptors.request.use(
  config => {
    const token = Cookie.get('token');
    if (token) config.headers['x-access-token'] = token;
    return config;
  },
  err => Promise.reject(err)
);

backendAPI.interceptors.response.use(
  response => {
    if (response.status === 200) {
      const { data } = response;
      return data;
    }
  },
  err => {
    // blob 物件轉 JSON
    if (
      err.request.responseType === 'blob' &&
      err.response.data instanceof Blob &&
      err.response.data.type &&
      err.response.data.type.toLowerCase().indexOf('json') != -1
    ) {
      return new Promise((resolve, reject) => {
        let reader = new FileReader();
        reader.onload = () => {
          err.response.data = JSON.parse(reader.result);
          resolve(Promise.reject(err.response.data));
        };

        reader.onerror = () => {
          reject(err.response.data);
        };

        reader.readAsText(err.response.data);
      });
    }

    // 一般的 response
    const { error } = err.response.data;
    if (error.message === 'jwt expired') Router.push({ name: 'Login' });
    return Promise.reject(error);
  }
);

export default backendAPI;
